export default __webpack_public_path__ + "assets/images/default-avatar-4379a4d4ac1c4fb909de79c53a9b58e1.png";